
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 9.333l-7.333-4 7.333-4 7.333 4-7.333 4zM8 12L1.05 8.217l1.4-.767L8 10.483l5.55-3.033 1.4.767L8 12zm0 2.667l-6.95-3.784 1.4-.766L8 13.15l5.55-3.033 1.4.766L8 14.667zm0-6.85l4.55-2.484L8 2.85 3.45 5.333 8 7.817z","fill":"currentColor"}})])
          )
        }
      }
    